function PrivacyPolicy() {
  return (
    <>
      <section className="page-header text-center text-white">
        <div className="container">
          <h1 className="fw-bold">Privacy Policy</h1>
          <p className="mb-0 opacity-75">Last updated: June 2025</p>
        </div>
      </section>

      <section className="py-5">
        <div className="container policy-content">
          <h4>1. Introduction</h4>
          <p>Garvit Education ("we", "our", "us") is committed to protecting the privacy of students, parents, and visitors who use our website and services. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.</p>

          <h4>2. Information We Collect</h4>
          <p>We may collect the following types of information:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, email address, phone number, date of birth, address, and academic details provided during enrollment or inquiry.</li>
            <li><strong>Payment Information:</strong> Payment details processed through secure third-party payment gateways.</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, time spent on pages, and other analytical data.</li>
            <li><strong>Communication Data:</strong> Records of correspondence when you contact us via email, phone, or forms.</li>
          </ul>

          <h4>3. How We Use Your Information</h4>
          <ul>
            <li>To process admissions and enrollment applications</li>
            <li>To communicate regarding courses, schedules, and academic updates</li>
            <li>To process payments and issue receipts</li>
            <li>To send promotional materials and updates (with your consent)</li>
            <li>To improve our website and services</li>
            <li>To comply with legal obligations</li>
          </ul>

          <h4>4. Data Sharing & Disclosure</h4>
          <p>We do not sell your personal information. We may share data with:</p>
          <ul>
            <li>University partners for academic processing</li>
            <li>Payment gateway providers for transaction processing</li>
            <li>Government authorities when required by law</li>
            <li>Service providers who assist in operating our website</li>
          </ul>

          <h4>5. Data Security</h4>
          <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.</p>

          <h4>6. Cookies</h4>
          <p>Our website uses cookies to enhance user experience. You can control cookie settings through your browser preferences.</p>

          <h4>7. Your Rights</h4>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent for marketing communications</li>
          </ul>

          <h4>8. Contact Us</h4>
          <p>For any privacy-related queries, contact us at:</p>
          <p><strong>Email:</strong> support@gencollege.in</p>
        </div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
